module.exports = __webpack_public_path__ + "img/adaptations12.53b6cc5e.png";